import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomOurStoresComponent} from './custom-our-stores.component';
import {CmsConfig, ConfigModule, I18nModule, provideDefaultConfig} from "@spartacus/core";
import {SpinnerModule} from "@spartacus/storefront";
import {reducerProvider, reducerToken} from "../../../../spartacus/custom/core/storefinder/store/reducers";
import {StoreModule} from "@ngrx/store";
import {STORE_FINDER_FEATURE} from "../../../../spartacus/custom/core/storefinder/store/selectors/custom-store-finder.states";
import {EffectsModule} from "@ngrx/effects";
import {effectsStoreFinder} from "../../../../spartacus/custom/core/storefinder/store/effects/custom-store-finder.effect";
import {CustomStoreFinderItemComponent} from "./custom-store-finder-item/custom-store-finder-item.component";
import {CustomIconsModule} from "../../../icons/custom-icons.module";
import {customStoreFinderConfig} from "../../../../spartacus/custom/core/storefinder/store/config/custom-store-finder.config";
import {CustomStoreFinderMapComponent} from './custom-store-finder-map/custom-store-finder-map.component';


@NgModule({
  declarations: [CustomOurStoresComponent, CustomStoreFinderItemComponent, CustomStoreFinderMapComponent],
  imports: [
    CommonModule,
    I18nModule,
    SpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OurStoresFlexComponent: {
          component: CustomOurStoresComponent,
        },
      },
    } as CmsConfig),
    EffectsModule.forFeature(effectsStoreFinder),
    StoreModule.forFeature(STORE_FINDER_FEATURE, reducerToken),
    CustomIconsModule,
  ],
  exports: [CustomStoreFinderItemComponent],
  providers: [
    reducerProvider,
    provideDefaultConfig(customStoreFinderConfig)
  ]
})
export class CustomOurStoresModule {}
